import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { ErrorLogsSearchRequest, ErrorLogsSearchResponse } from 'src/app/shared/models/errorlogs.model';


@Component({
  selector: 'app-errorlogs-table',
  templateUrl: './errorlogs-table.component.html',
  styleUrls: ['./errorlogs-table.component.scss']
})
export class ErrorlogsTableComponent {
  @Input() public errorLogs: ErrorLogsSearchResponse | undefined;
  @Output() public updateRequestAndSearch = new EventEmitter<ErrorLogsSearchRequest>();

  lazyLoad(event: TableLazyLoadEvent): void {
    if (!this.errorLogs) return;

    const originalRequest = this.errorLogs.originalRequest;
    if (originalRequest.pageFirstRow !== event.first || originalRequest.pageSize !== event.rows ||
      originalRequest.sortField !== event.sortField || originalRequest.sortOrder !== event.sortOrder) {
      const request = {
        pageFirstRow: event.first,
        pageSize: event.rows,
        sortField: event.sortField,
        sortOrder: event.sortOrder,
      } as ErrorLogsSearchRequest;
      this.updateRequestAndSearch.emit(request);
    }
  }
}
